import { Pipe, PipeTransform } from 'ng-metadata/core';

/**
 * @ngdoc filter
 * @name mwTruncate
 * @module mw.components.dataFormatting
 *
 * @param {array} [text] - An array of strings to be truncated if need be
 * @param {number} [length] - What you want these strings to be truncated to
 * @param {string} [end] - What you want appended to the end of your string after truncation
 * @returns {string} a new string based on your truncation settings
 *
 * @description
 * `truncate` truncates a string based on how many characters you want to truncate after
 */
@Pipe({
    name: 'mwTruncate'
})
export class TruncatePipe implements PipeTransform {
    ELLIPSIS: string = '...'

    isUsable(objs: any) {
        let allUsable = true;

        if (objs instanceof Array === false) {
            objs = [objs];
        }

        for (let key in objs) {
            if (objs[key] === undefined || objs[key] === null || objs[key] === '') {
                allUsable = false;
                break;
            }
        }

        return allUsable;
    }

    transform(text: Array<string>, length: number, end: any): any {
         if (!this.isUsable(text)) {
              return text;
         }
        if (isNaN(length))
            length = 10;

        if (end === undefined)
            end = this.ELLIPSIS;

        if (text.length <= length) {
            return text;
        } else {
            return String(text).substring(0, length - end.length) + end;
        }
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/data-formatting/truncate.pipe.ts